import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchPublicOrderTracking } from './apiAdapters';
import { mapOrderTracking } from './mapper';

// Giữ nguyên tên và chữ ký 2 hook cũ để 3 màn đang import không phải sửa gì.
// Cùng queryKey nên form → màn chi tiết → màn khiếu nại chỉ gọi API 1 lần trong staleTime 5 phút.
const trackingKey = ({ orderCode, phoneNumber } = {}) => ['publicOrderTracking', orderCode, phoneNumber];

const trackingQueryFn = (params) => ({ signal }) => fetchPublicOrderTracking(params, { signal });

export const useGetTrackingDetail = (params) => {
  // Bản GraphQL cũ chỉ skip khi thiếu CẢ hai, nên thiếu 1 trong 2 vẫn gọi API và chắc chắn lỗi 400.
  // Ở đây phải đủ cả hai mới gọi.
  const { data, isFetching, refetch } = useQuery({
    queryKey: trackingKey(params),
    queryFn: trackingQueryFn(params),
    select: mapOrderTracking,
    enabled: !!params?.orderCode && !!params?.phoneNumber,
  });

  return { data, loading: isFetching, refetch };
};

export function useLazyGetTrackingDetail() {
  const queryClient = useQueryClient();

  // Form cần biết kết quả NGAY để quyết định có điều hướng hay không, nên dùng fetchQuery thay vì
  // useQuery. Dữ liệu thô vào cache; màn chi tiết mở ra tự map qua `select`, không gọi API lần 2.
  const getOrderDetail = ({ variables } = {}) =>
    queryClient.fetchQuery({ queryKey: trackingKey(variables), queryFn: trackingQueryFn(variables) });

  return { getOrderDetail };
}
